module.exports = __webpack_public_path__ + "static/media/GalleryMain2.e1d3ca2e.jpg";